import React from 'react'
import AgriImport from './_agri-import'

export default class MeatImport extends React.Component {
  render = () => {
    const { props } = this

    const aprops = {
      resource: '/meat_import_licenses',
      form_key: 'meat_import_license',
      _sid: 'meat import license',
      service: props.service,
      form_name: 'Meat',
      importProps: {
        metric_list: [
          'Each Per Item',
          'Cases per item',
          'Bags per item',
          'Bins per item',
          'Pounds per item',
          'Sacks per item',
        ],
        hide_scientific: true,
      },
      ...props,
    }

    return (
      <>
        <AgriImport {...aprops} />
      </>
    )
  }
}
